module.exports = __webpack_public_path__ + "img/20240427142200453ld8.d8a2d75d.jpg";